import React, {FC} from 'react';
import {Button, Link} from '@bonprix/design-system';

import Landmark from '@core/scripts/components/landmark-adapter';
import {openPrivacyCenter} from '@consent/scripts/modules/consent-functions.js';

import type {StaticLinks} from './CheckoutFooter';
import {TrinityEvents} from '@checkout/components/tracking/trinity-events';
import {EventObjectType} from '@checkout/components/tracking/model/EventObjectType';

interface LegalLinksProps {
    texts: any;
    staticLinks: StaticLinks;
}

const LegalLinks: FC<LegalLinksProps> = ({texts, staticLinks}) => {
    const onTermsAndConditionsTextClick = () => {
        Landmark.sendClickLandmark('agb_on_checkout');
    };
    const onPrivacyTextClick = () => {
        Landmark.sendClickLandmark('layer_privacy');
    };

    const onPrivacyCenterTextClick = () => {
        openPrivacyCenter();
    };

    const onWithdrawContractClick = () => {
        const clickAttributes = TrinityEvents.getClickAttributes('withdrawContract', undefined, EventObjectType.LINK);
        TrinityEvents.createAndSendTrinityEvent(6, 'CLICK_FOOTER_BOTTOMLINKS', clickAttributes);
    };

    return (
        <nav className="checkout-footer__legal-links">
            <ul className="p-0 flex flex-col gap-4 items-center list-none">
                <li>
                    <Button
                        component="a"
                        variant="secondary"
                        contentWidth
                        href={staticLinks.SERVICE_WITHDRAW_CONTRACT}
                        target="_blank"
                        onClick={onWithdrawContractClick}
                    >
                        {texts.withdraw}
                    </Button>
                </li>
                <li>
                    <Link
                        href={staticLinks.SERVICE_TERMS_AND_CONDITIONS}
                        target="_blank"
                        onClick={onTermsAndConditionsTextClick}
                    >
                        {texts.termsAndConditions}
                    </Link>
                </li>
                <li>
                    <Link href={staticLinks.SERVICE_IMPRINT} target="_blank" onClick={() => {}}>
                        {texts.imprint}
                    </Link>
                </li>
                <li>
                    <Link href={staticLinks.SERVICE_PRIVACY} target="_blank" onClick={() => onPrivacyTextClick}>
                        {texts.privacy}
                    </Link>
                </li>
                <li>
                    <Link component="button" onClick={onPrivacyCenterTextClick}>
                        {texts.privacyCenter}
                    </Link>
                </li>
                <li>
                    <Link href={staticLinks.SERVICE_ACCESSIBILITY} target="_blank">
                        {texts.accessibility}
                    </Link>
                </li>
                <li>
                    <Link href={staticLinks.SERVICE_STATUTORY_WARRANTY} target="_blank" rel="noopener">
                        {texts.legalGuarantee}
                    </Link>
                </li>

            </ul>
        </nav>
    );
};

export default LegalLinks;
